module.exports = __webpack_public_path__ + "img/patio-art.b99b9bd2.webp";